import { getRandomInteger } from '../helpers/functions';

export const users = [
  ['Leo', 'Tolstoy', getRandomInteger()],
  ['William', 'Shakespeare', getRandomInteger()],
  ['James', 'Joyce', getRandomInteger()],
  ['Vladimir', 'Nabokov', getRandomInteger()],
  ['Fyodor', 'Dostoevsky', getRandomInteger()],
  ['William', 'Faulkner', getRandomInteger()],
  ['Charles', 'Dickense', getRandomInteger()],
  ['Anton', 'Chekhov', getRandomInteger()],
  ['Scott', 'Fitzgerald', getRandomInteger()],
  ['Marcel', 'Proust', getRandomInteger()],
  ['Virginia', 'Woolf', getRandomInteger()],
  ['Gustave', 'Flaubert', getRandomInteger()],
  ['Mark', 'Twain', getRandomInteger()],
  ['George', 'Eliot', getRandomInteger()],
  ['Herman', 'Melville', getRandomInteger()],
  ['Jane', 'Austen', getRandomInteger()],
  ['William', 'Bradford', getRandomInteger()],
  ['Victor', 'Hugo', getRandomInteger()],
  ['Miguel', 'de Cervantes', getRandomInteger()],
  ['Ernest', 'Hemingway', getRandomInteger()],
  ['Oscar', 'Wilde', getRandomInteger()],
  ['John', 'Stainbeck', getRandomInteger()],
  ['F.Scott', 'Fitzgerald', getRandomInteger()],
  ['Friedrich', 'Nietzche', getRandomInteger()],
  ['Artur', 'Conan Doyle', getRandomInteger()],
  ['Jonathan', 'Swift', getRandomInteger()],
  ['Jules', 'Verne', getRandomInteger()],
  ['Aleksandr', 'Barnov', getRandomInteger()],
];
